var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdDomElement } from "../../../constants/IdDomElement";
import { utilAnimation, } from "../../../utils/animation/utilAnimation";
import { utilHash } from "../../../utils/utilHash";
import { List } from "../../generic/list/List";
// TODO refactor to functional component
var AnimationLevelUp = /** @class */ (function (_super) {
    __extends(AnimationLevelUp, _super);
    function AnimationLevelUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fireworkDotItems = new Map();
        _this.fireworkRunningAnimation = {};
        _this.getFireworkContainer = function () {
            var fireworkGroupItem = [];
            var fireworkGroupAmount = 20;
            var fireworkGroupPositions = new Map();
            var randomMinXSize = window.innerWidth * 0.1;
            var randomMaxXSize = window.innerWidth * 0.9;
            var randomMinYSize = window.innerHeight * 0.1;
            var randomMaxYSize = window.innerHeight * 0.9;
            for (var i = 0; i < fireworkGroupAmount; i++) {
                var randomXPos = randomMinXSize + Math.random() * (randomMaxXSize - randomMinXSize);
                var randomYPos = randomMinYSize + Math.random() * (randomMaxYSize - randomMinXSize);
                var position = {
                    x: randomXPos,
                    y: randomYPos,
                };
                var elementId = utilHash.md5Hash({ id: i });
                var time = 1 + Math.random();
                fireworkGroupItem.push({
                    elementId: elementId,
                    position: position,
                    time: time,
                });
                fireworkGroupPositions.set(elementId, position);
            }
            return React.createElement(List, { items: fireworkGroupItem, renderItem: _this.renderFireworkGroupItem });
        };
        _this.renderFireworkGroupItem = function (items) {
            var fireworkDotAmount = 15;
            var fireworkDotsItem = [];
            for (var i = 0; i < fireworkDotAmount; i++) {
                fireworkDotsItem.push({
                    elementId: "#" + items.elementId + "_" + utilHash.md5Hash({ explosionId: i }),
                    time: items.time,
                });
            }
            _this.fireworkDotItems.set(items.elementId, fireworkDotsItem);
            return (React.createElement("div", { id: "#" + items.elementId, key: "emitter_" + items.elementId, className: "level-up__animation-emitter", style: { top: items.position.y + "px", left: items.position.x + "px" } },
                React.createElement(List, { items: fireworkDotsItem, renderItem: _this.renderFireworkDotItem })));
        };
        _this.renderFireworkDotItem = function (item) {
            return (React.createElement("div", { key: item.elementId, id: "" + item.elementId, className: "level-up__animation-dot" }));
        };
        _this.startAnimation = function (items) {
            if (items.size > 0) {
                items.forEach(function (item) {
                    setTimeout(function () {
                        _this.startExplosion(item);
                    }, Math.random() * 10 * 1000);
                });
            }
        };
        _this.startExplosion = function (explosions) {
            explosions.forEach(function (value) {
                _this.fireworkRunningAnimation[value.elementId] = utilAnimation.createFireworkExplosion(value, _this.restartAnimation);
            });
        };
        _this.restartAnimation = function (id) {
            if (_this.fireworkRunningAnimation.hasOwnProperty(id)) {
                _this.fireworkRunningAnimation[id].restart();
            }
        };
        _this.killAnimation = function () {
            Object.keys(_this.fireworkRunningAnimation).forEach(function (value) {
                if (_this.fireworkRunningAnimation.hasOwnProperty(value)) {
                    _this.fireworkRunningAnimation[value].kill();
                }
            });
        };
        return _this;
    }
    AnimationLevelUp.prototype.componentDidMount = function () {
        if (this.fireworkDotItems.size > 0) {
            this.startAnimation(this.fireworkDotItems);
        }
    };
    AnimationLevelUp.prototype.componentWillUnmount = function () {
        this.killAnimation();
    };
    AnimationLevelUp.prototype.render = function () {
        // FIXME: fix fps, then remove the next line.
        return React.createElement(React.Fragment, null);
        var fireworkContainer = this.getFireworkContainer();
        return (React.createElement("div", { id: IdDomElement.LevelUpAnimation, className: "w100 h100 level-up__animation-position" }, fireworkContainer));
    };
    return AnimationLevelUp;
}(React.Component));
export { AnimationLevelUp };



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/level-up-animation/AnimationLevelUp.tsx
// module id = 2557
// module chunks = 3